import { func, object } from "prop-types";
import React from "react";

export function ErrorFallback({ error, resetErrorBoundary }) {
	return (
		<div role="alert">
			<p>Something went wrong:</p>
			<pre>{error.message}</pre>
			<button onClick={resetErrorBoundary}>Try again</button>
		</div>
	);
}

ErrorFallback.propTypes = {
	error: object,
	resetErrorBoundary: func,
};
